<template lang="pug">
#nav-footer(:class='{ loading: $store.state.isLoading }')
  .desktop
    .footer-col
      h4.footer-header SOCIAL MEDIA
      a(href='https://www.facebook.com/LEGOCertifiedStoreMalaysiaALJ', target='_blank')
        img.social-media(v-lazy='require(\'../assets/images/icons/facebook-logo.png\')')
      a(href='https://www.instagram.com/legocertifiedstoremalaysia_alj/', target='_blank')
        img.social-media(v-lazy='require(\'../assets/images/icons/instagram.png\')')
    .footer-col
      h4.footer-header CUSTOMER SERVICE
      ul
        li
          router-link(to='/faq/general-enquiries') FAQs
        li
          router-link(to='/terms-conditions') Terms &amp; Conditions
        li
          router-link(to='/shipping-delivery') Shipping &amp; Delivery
    .footer-col
      h4.footer-header ABOUT US
      ul
        li
          router-link(to='/about/overview') About LEGO&reg;
        li
          router-link(to='/contact-us') Contact Us
        li
          router-link(to='/store-locator/1') Store Locator
        li
          router-link(to='/vib-membership') VIB Membership
    .footer-col
      h4.footer-header PAYMENT METHOD
      img.footer-image(v-lazy='require(\'../assets/images/icons/ipay88.png\')')
      img.footer-image(v-lazy='require(\'../assets/images/icons/lego-certified.png\')')

  .mobile
    .footer-col
      h4.footer-header SOCIAL MEDIA
      a(href='https://www.facebook.com/LEGOCertifiedStoreMalaysiaALJ', target='_blank')
        img.social-media(v-lazy='require(\'../assets/images/icons/facebook-logo.png\')')
      a(href='https://www.instagram.com/legocertifiedstoremalaysia_alj/', target='_blank')
        img.social-media(v-lazy='require(\'../assets/images/icons/instagram.png\')')
    .footer-col
      h4.footer-header PAYMENT METHOD
      img.footer-image(v-lazy='require(\'../assets/images/icons/ipay88.png\')')

    .footer-col
      h4.footer-header CUSTOMER SERVICE
      ul
        li
          router-link(to='/faq') FAQs
        li
          router-link(to='/terms-conditions') Terms &amp; Conditions
        li
          router-link(to='/shipping-delivery') Shipping &amp; Delivery
    .footer-col
      h4.footer-header ABOUT US
      ul
        li
          router-link(to='/about/overview') About LEGO&reg;
        li
          router-link(to='/contact-us') Contact Us
        li
          router-link(to='/store-locator') Store Locator
        li
          router-link(to='/vib-membership') VIB Membership
    .footer-col.certified
      img.footer-image(v-lazy='require(\'../assets/images/icons/lego-certified.png\')')
</template>

<script>
export default {}
</script>

<style lang="sass" scoped>
@import '../sass/_variables'

#nav-footer
  background-color: #EAEAEA
  padding-top: 64px
  padding-left: 38px
  padding-bottom: 80px
  box-sizing: border-box
  +mobile
    margin-left: 0
    padding: 37px 20px 40px 17px
  .mobile, .desktop
    display: flex
    flex-wrap: wrap
  &.loading
    // margin-top: 100vh
  .footer-col
    flex: 0 0 25%
    padding-left: 40px
    box-sizing: border-box
    +mobile
      flex: 0 0 50%
      padding-left: 20px
    &.certified
      +mobile
        flex: 0 0 100%
        margin-top: 20px
        display: block
        margin: 20px auto 0 auto
      img
        margin: 20px auto 0 auto
    .social-media
      margin-right: 6px
    .footer-header
      color: black
      font-weight: 900
      font-size: 20px
      margin-bottom: 8px
      margin-top: 0
      +mobile
        font-size: 13px
    .footer-image
      display: block
      margin-bottom: 10px
    li
      font-size: 18px
      padding: 5px 0
      +mobile
        font-size: 11px
</style>
